export const SALON = {
    name: "Moovie Parrucchieri",
    legalName: "Moovie Parrucchieri Snc di Battista Alessandra & C.",
    address: "Via Postumia, 166A — 31038 Paese (TV)",
    phoneDisplay: "+39 0422 452129",
    phoneHref: "tel:+390422452129",
    rating: "4,9",
    reviewCount: "34",
    googleReviewsUrl:
        "https://www.google.com/maps/search/?api=1&query=Moovie+Parrucchieri+Via+Postumia+166A+Paese+TV",
    mapsEmbed:
        "https://www.google.com/maps?q=Via+Postumia+166A,+31038+Paese+TV,+Italia&output=embed",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwaGFpciUyMHN0eWxpbmclMjB3b21hbnxlbnwwfHx8fDE3ODk2NDk4OTN8MA&ixlib=rb-4.1.0&q=85",
    bridal: "/images/sposa.jpg",
    wash: "https://images.pexels.com/photos/7755473/pexels-photo-7755473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    staff: "/images/staff.jpg",
    cerimonia: "/images/cerimonia.jpg",
    zonaShampoo: "/images/zona-shampoo.jpg",
    prodotti: "/images/prodotti.jpg",
    postazioni: "/images/postazioni.jpg",
    styling: "/images/ramata.jpg",
};

export const NAV_LINKS = [
    { label: "Chi Siamo", href: "#chi-siamo" },
    { label: "Servizi", href: "#servizi" },
    { label: "Esperienza", href: "#esperienza" },
    { label: "Galleria", href: "#galleria" },
    { label: "Recensioni", href: "#recensioni" },
    { label: "Contatti", href: "#contatti" },
];

export const SERVICES = [
    {
        n: "01",
        title: "Taglio Donna",
        desc: "Un taglio costruito su misura, dopo una consulenza vera: forma del viso, texture, abitudini. Anche su capelli molto lunghi o difficili.",
    },
    {
        n: "02",
        title: "Taglio Uomo",
        desc: "Precisione, pulizia e uno stile facile da gestire ogni giorno. Dal classico al contemporaneo, senza fretta.",
    },
    {
        n: "03",
        title: "Piega",
        desc: "Liscia, mossa o riccia: la piega che dura e rispetta il capello. Con il nostro rituale di shampoo e massaggio incluso.",
    },
    {
        n: "04",
        title: "Colore",
        desc: "Colorazioni professionali e copertura perfetta, scelte insieme a te in consulenza per valorizzare incarnato e stile.",
    },
    {
        n: "05",
        title: "Colpi di Sole & Balayage",
        desc: "Schiariture naturali e sfumature luminose, studiate sulla tua base. Effetto sole, manutenzione leggera.",
    },
    {
        n: "06",
        title: "Trattamenti Ricostruttivi",
        desc: "Rituali di cura profonda per capelli stressati, rovinati o trattati: forza, morbidezza e lucentezza ritrovate.",
    },
    {
        n: "07",
        title: "Acconciature da Cerimonia",
        desc: "Raccolti e semi-raccolti per spose, testimoni e invitate. Eleganza che regge tutto il giorno, prova inclusa.",
    },
];

export const HOURS = [
    { day: "Lunedì", time: "Chiuso", closed: true },
    { day: "Martedì", time: "9:00–13:00 · 15:00–19:00" },
    { day: "Mercoledì", time: "9:00–13:00 · 15:00–19:00" },
    { day: "Giovedì", time: "9:30–18:30" },
    { day: "Venerdì", time: "9:30–18:30" },
    { day: "Sabato", time: "9:00–17:00" },
    { day: "Domenica", time: "Chiuso", closed: true },
];

export const REVIEWS = [
    {
        text: "Molto professionali e cordiali. Sono riuscite a rimediare a un disastro fatto da un'altra parrucchiera... darei venti se potessi. Molto importante: ricevono su appuntamento e rispettano gli orari, ma se hai un problema un buco lo trovano quasi sempre.",
    },
    {
        text: "Wonderfully helpful and knowledgeable. They're attentive to requests and know how to give the right advice when we're unsure. The prices are excellent, and since I first came here (now 6 years ago), they've become my go-to place.",
    },
    {
        text: "Super welcoming place. I showed them a photo of my hair and they immediately advised me on what would be best for me. At the hair wash they even gave me a scalp massage, which they almost never do elsewhere!",
    },
];

export const FAQS = [
    {
        q: "Serve la prenotazione?",
        a: "Sì, riceviamo su appuntamento per dedicare a ogni persona il tempo che merita, senza attese. Ma se hai un'urgenza, chiamaci: troviamo quasi sempre uno spazio.",
    },
    {
        q: "Quanto costa un taglio?",
        a: "I nostri prezzi sono onesti e tra i più apprezzati dalle clienti. Il costo esatto dipende dal servizio e dalla lunghezza: in consulenza, prima di iniziare, ti diciamo sempre tutto con trasparenza.",
    },
    {
        q: "Fate consulenze colore?",
        a: "Sì, e sono gratuite. Prima di qualsiasi colore o balayage analizziamo insieme base, incarnato e manutenzione, per scegliere la nuance giusta per te — anche partendo da una semplice foto.",
    },
    {
        q: "Lavorate anche capelli molto lunghi o difficili?",
        a: "È una delle cose che le clienti ci riconoscono di più. Capelli lunghi, ricci impegnativi o situazioni da sistemare: li prendiamo come una sfida professionale, non come un problema.",
    },
    {
        q: "Dove siete e dove parcheggio?",
        a: "Siamo in Via Postumia 166A a Paese (TV), facilmente raggiungibili da Treviso e dai comuni vicini. Nelle vicinanze del salone trovi comodi parcheggi.",
    },
];
